module.exports = __webpack_public_path__ + "img/114.78ab3c8e.jpg";